import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useAtom } from 'jotai';

import { getStaffOffices } from '@/api/getStaffOffices';
import Button from '@/components/Button/Button';
import { LineUserAtom } from '@/jotai/jotai';
import { Office } from '@/types/office';

export const StaffOffices = () => {
  const navigate = useNavigate();
  const [lineUser, _] = useAtom(LineUserAtom);
  const [offices, setOffices] = useState<Office[]>();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirect = searchParams.get('redirect') ?? 'transport';
  useEffect(() => {
    fetchOffices();
  }, [lineUser]);

  const fetchOffices = async () => {
    try {
      const result = await getStaffOffices(lineUser?.lineID ?? '', lineUser?.accessToken ?? '');
      if (result.status === 200) {
        setOffices(result.result);
      }
    } catch (error) {
      console.error('officeIDの取得に失敗しました', error);
    }
  };

  return (
    <div className="mx-4 text-[22px]">
      <div className="my-4 font-bold">事業所を選択してください</div>
      <div className="space-y-4">
        {offices?.map((office) => (
          <Button
            key={office.id}
            className="w-full"
            variant="solid-fill"
            size="lg"
            type="button"
            onClick={() => navigate(`/staff/offices/${office.id}/${redirect}`)}
          >
            {office.name}
          </Button>
        ))}
      </div>
    </div>
  );
};
